import { useQuery } from "@tanstack/react-query";
import { TravelCardRequestService } from "../../../../../services/company-office/TravelCardRequest";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { transformRequestStatus } from "../../../utils";
import { useSelector } from "../../../../../store/store";

export const useVehicleTravelCardRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["vehicle-travel-card-requests"],
    queryFn: () => TravelCardRequestService.getTravelCardRequests(userEmail),
  });

  const vehicleTravelCardMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const processedData = data
    .map((record) => {
      const status = getStatusBaseOnApprover(record.fields, userEmail);
      const step = getStepBaseOnApprover(record.fields, userEmail);

      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedVehicleTravelCardRequests = processedData
    .filter((record) => [record.eAssignee, record.eApprovedByITLead, record.eApprovedByITHead, record.eApprovedBy].some((approver) => approver?.toLowerCase().includes(userEmail.toLowerCase())))

  const mappedVehicleTravelCardMyRequests = processedData
    .filter((record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase())

  const guideLink = "https://drive.google.com/file/d/1qt1eMsOo6BFS42D9ocBgsAk0lcvgM0uZ/view";

  return {
    ...restResponse,
    vehicleTravelCardRequests: data,
    vehicleTravelCardMyRequests,
    mappedVehicleTravelCardRequests,
    mappedVehicleTravelCardMyRequests,
    guideLink
  };
};
